import { analytics } from '../analytics';
import { CHART_EVENT_IDS } from '../events/eventIds';
import { generateRandomIPAddress } from '../utils';

export enum CHART_IDS {
  report_status_totals = 'report_status_totals',
  report_status_progress = 'report_status_progress',
  intake_methods_per_category = 'intake_methods_per_category',
  departments_across_locations = 'departments_across_locations',
  categories_per_department = 'categories_per_department',
  categories_over_time = 'categories_over_time',
  report_substantiation_totals = 'report_substantiation_totals',
  case_time_to_resolution = 'case_time_to_resolution',
}

export enum METRIC_IDS {
  total_cases = 'total_cases',
  location = 'location',
  department = 'department',
  category = 'category',
  month = 'month',
  time_to_resolution = 'time_to_resolution',
  time_in_new = 'time_in_new',
  time_in_read = 'time_in_read',
  time_in_investigating = 'time_in_investigating',
  cases_over_90_days = 'cases_over_90_days',
}

export const trackChartExported = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_EXPORTED,
    {
      organisation_id,
      dashboard,
      chart_id,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartUpdated = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
  action: 'filter' | 'group',
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_UPDATED,
    {
      organisation_id,
      dashboard,
      chart_id,
      action,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartFiltered = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
  filters: string[],
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_FILTERED,
    {
      organisation_id,
      dashboard,
      chart_id,
      filters,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackDashboardFiltered = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  filter: string,
) => {
  return analytics.track(
    CHART_EVENT_IDS.DASHBOARD_FILTERED,
    {
      organisation_id,
      dashboard,
      filter,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartRedrawn = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_REDRAWN,
    {
      organisation_id,
      dashboard,
      chart_id,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartViewChanged = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
  view_id: string,
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_VIEW_CHANGED,
    {
      organisation_id,
      dashboard,
      chart_id,
      view_id,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartGrouped = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  chart_id: CHART_IDS,
  group_id: string,
  group_var: string,
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_GROUPED,
    {
      organisation_id,
      dashboard,
      chart_id,
      group_id,
      group_var,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackMetricTooltipViewed = (
  organisation_id: string,
  dashboard: 'organisational' | 'operational',
  metric_id: METRIC_IDS,
) => {
  return analytics.track(
    CHART_EVENT_IDS.METRIC_TOOLTIP_VIEWED,
    {
      organisation_id,
      dashboard,
      metric_id,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackChartDownloaded = (
  organisation_id: string,
  dashboard_id: 'organisational' | 'operational',
  chart_id: CHART_IDS,
  export_format: string,
) => {
  return analytics.track(
    CHART_EVENT_IDS.CHART_DOWNLOADED,
    {
      organisation_id,
      dashboard_id,
      chart_id,
      export_format,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};
